module.exports = __webpack_public_path__ + "img/mappingDone.dd3dab5d.svg";